import {useContext, useMemo} from 'react';

import type {CommonProps} from './types';

import {getColor, ThemeContext} from '../../styles';
import {lottieColorify} from './colorify';

export const useAnimationSource = (
  source: CommonProps['source'],
  colorify?: CommonProps['colorify'],
) => {
  const {theme} = useContext(ThemeContext);

  const result = useMemo(() => {
    switch (typeof source) {
      case 'function': {
        const defaultColor = theme.color.v3.icon.primary;

        if (!colorify) {
          return source(defaultColor);
        }

        const themeColor = getColor(colorify.color)({theme});

        return source(themeColor || defaultColor);
      }
      default: {
        return colorify
          ? lottieColorify({
              color: colorify.color,
              layers: colorify.layers,
              source,
            })
          : source;
      }
    }
  }, [colorify, source, theme]);

  return result;
};
